// extracted by mini-css-extract-plugin
export default {"page-footer":"Footer_page-footer__hatdL","references":"Footer_references__qN0Wj","tmdb-reference-logo":"Footer_tmdb-reference-logo__rFaK7"};